<div class="item loading-2">
    <div class="spinner">
        <div class="circle circle-1">
            <div class="circle-inner"></div>
        </div>
        <div class="circle circle-2">
            <div class="circle-inner"></div>
        </div>
    </div>
</div>

<style type="text/css">
    .loading-2{margin-bottom: -2px;}
    .loading-2 .spinner * {
        box-sizing: border-box;
    }
    .loading-2 .spinner {
        display: inline-block;
        animation-name: anim-spinner;
        animation-duration: 0.7s;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
    }
    .loading-2 .spinner .circle {
        width: 1em;
        height: 0.5em;
        overflow: hidden;
    }
    .loading-2 .spinner .circle-inner {
        transform: rotate(45deg);
        border-radius: 50%;
        border: 0.15em solid white;
        border-right: 0.15em solid transparent;
        border-bottom: 0.15em solid transparent;
        width: 100%;
        height: 200%;
        animation-name: anim-circle-1;
        animation-duration: 0.7s;
        animation-iteration-count: infinite;
        animation-direction: alternate;
        animation-timing-function: cubic-bezier(0.25, 0.1, 0.5, 1);
    }
    .loading-2 .spinner .circle-2 {
        transform: rotate(180deg);
    }
    .loading-2 .spinner .circle-2 .circle-inner {
        animation-name: anim-circle-2;
    }
    @keyframes anim-circle-1 {
        from {
            transform: rotate(60deg);
        }
        to {
            transform: rotate(205deg);
        }
    }
    @keyframes anim-circle-2 {
        from {
            transform: rotate(30deg);
        }
        to {
            transform: rotate(-115deg);
        }
    }
    @keyframes anim-spinner {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
</style>